import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';

// 말소대행 거래처(agency_clients) 관리 — Excel 장부 대체 Phase 2.
// 거래처별 차등 수수료/원부/재교부 단가 + 회사(테넌트) 연결 + 사업자등록증 OCR 자동채움 + 검색.
// cancel_agency: 본인 대행사 거래처(backend 가 req.user.agencyId 강제) / admin·doc_agency: 대행사 선택 후 관리.
function CancelAgencyClients({ showToast, user, agencies, isCancelAgency }) {
  var fmt = function(n){ return (parseInt(n)||0).toLocaleString(); };
  var [agencyId, setAgencyId] = useState('');     // admin/doc_agency 선택값 (cancel_agency 는 backend override)
  var [clients, setClients] = useState([]);
  var [linkable, setLinkable] = useState([]);
  var [editId, setEditId] = useState(null);        // 수정 중인 거래처 id
  var [showAdd, setShowAdd] = useState(false);
  var [form, setForm] = useState(null);
  var [q, setQ] = useState('');                    // 거래처 검색어 (거래처명/사업자번호/연결회사)
  var [ocrLoading, setOcrLoading] = useState(false);

  var canQuery = function(){ return isCancelAgency || !!agencyId; };
  var qs = function(){ return (!isCancelAgency && agencyId) ? ('?agencyId=' + agencyId) : ''; };

  var load = function(){
    if(!canQuery()){ setClients([]); setLinkable([]); return; }
    authFetch(API+'/agency-clients'+qs()).then(function(r){return r.json()}).then(function(d){ setClients(Array.isArray(d)?d:[]) }).catch(function(){});
    authFetch(API+'/agency-clients/linkable'+qs()).then(function(r){return r.json()}).then(function(d){ setLinkable(Array.isArray(d)?d:[]) }).catch(function(){});
  };
  useEffect(function(){ load(); }, [agencyId, isCancelAgency]); // eslint-disable-line react-hooks/exhaustive-deps

  var blankForm = function(){ return {name:'',bizNo:'',companyId:'',serviceFee:'',reissueFee:'',wonbuFee:'',issueTaxInvoice:1,active:1,memo:''}; };
  var startEdit = function(c){
    setShowAdd(false); setEditId(c.id);
    // legacy/undefined → 발행형(1) default; 명시적 0 만 비발행
    setForm({ name:c.name||'', bizNo:c.bizNo||'', companyId:c.companyId?String(c.companyId):'', serviceFee:String(c.serviceFee||''), reissueFee:String(c.reissueFee||''), wonbuFee:String(c.wonbuFee||''), issueTaxInvoice:(c.issueTaxInvoice===0?0:1), active:c.active, memo:c.memo||'' });
  };
  var startAdd = function(){ setEditId(null); setShowAdd(true); setForm(blankForm()); };
  var cancel = function(){ setEditId(null); setShowAdd(false); setForm(null); };
  var setF = function(k,v){ setForm(function(p){ if(!p) return p; var n={}; for(var x in p)n[x]=p[x]; n[k]=v; return n; }); };

  // 사업자등록증 업로드 → OCR(상호/사업자번호) 자동채움. 수동입력 대체.
  var ocrBizLicense = function(file){
    if(!file) return;
    setOcrLoading(true);
    var fd = new FormData(); fd.append('image', file);
    authFetch(API+'/admin/companies/ocr-biz-license',{ method:'POST', body:fd })
      .then(function(r){return r.json()}).then(function(d){
        setOcrLoading(false);
        if(d && d.error){ showToast(d.error,'err'); return; }
        // 응답 구조: { success:true, data:{ name, bizNo, ... } } — 결과는 .data 아래 중첩
        var info = (d && d.data) ? d.data : (d || {});
        var got = false;
        if(info.name){ setF('name', info.name); got = true; }
        if(info.bizNo){ setF('bizNo', info.bizNo); got = true; }
        showToast(got ? '사업자등록증 인식 완료' : '인식했으나 상호/사업자번호를 못 읽었습니다 — 수동 입력', got ? undefined : 'err');
      }).catch(function(){ setOcrLoading(false); showToast('인식 실패','err'); });
  };

  var buildBody = function(){
    return {
      name: (form.name||'').trim(),
      bizNo: (form.bizNo||'').trim(),
      companyId: form.companyId ? parseInt(form.companyId) : 0,
      serviceFee: parseInt(form.serviceFee)||0,
      reissueFee: parseInt(form.reissueFee)||0,
      wonbuFee: parseInt(form.wonbuFee)||0,
      issueTaxInvoice: form.issueTaxInvoice?1:0,
      active: form.active?1:0,
      memo: form.memo||'',
      agencyId: (!isCancelAgency && agencyId) ? parseInt(agencyId) : undefined
    };
  };
  var save = function(){
    if(!form.name||!form.name.trim()){ showToast('거래처명을 입력하세요','err'); return; }
    var url = editId ? (API+'/agency-clients/'+editId) : (API+'/agency-clients');
    authFetch(url,{ method: editId?'PUT':'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify(buildBody()) })
      .then(function(r){return r.json()}).then(function(d){
        if(d.success){ showToast(editId?'수정 완료':'거래처 추가 완료'); cancel(); load(); }
        else { showToast(d.error||'저장 실패','err'); }
      }).catch(function(){ showToast('저장 실패','err'); });
  };
  var remove = function(c){
    if(!window.confirm('거래처 "'+c.name+'" 을(를) 삭제할까요?')) return;
    authFetch(API+'/agency-clients/'+c.id+qs(),{method:'DELETE'}).then(function(r){return r.json()}).then(function(d){
      if(d.success){ showToast('삭제 완료'); load(); } else { showToast(d.error||'삭제 실패','err'); }
    }).catch(function(){ showToast('삭제 실패','err'); });
  };

  var blankCount = clients.filter(function(c){ return !c.serviceFee; }).length;
  // 검색 필터 (거래처명/사업자번호/연결회사)
  var shown = clients.filter(function(c){
    if(!q.trim()) return true;
    var s = q.trim().toLowerCase();
    return (c.name||'').toLowerCase().indexOf(s)>=0 || (c.bizNo||'').toLowerCase().indexOf(s)>=0 || (c.companyName||'').toLowerCase().indexOf(s)>=0;
  });
  // 연결 회사 드롭다운: linkable + (편집 중 현재 연결값이 목록에 없으면 보존)
  var companyOptions = function(curId, curName){
    var opts = linkable.slice();
    if(curId && !opts.some(function(o){return String(o.id)===String(curId)})) opts = [{id:curId, name:(curName||('#'+curId))}].concat(opts);
    return opts;
  };

  var cellInput = function(k, ph, w){
    return <input value={form[k]} onChange={function(e){setF(k,e.target.value)}} placeholder={ph||''} style={{width:w||70,padding:'4px 6px',border:'1px solid #cbd5e1',borderRadius:6,textAlign:(k==='name'||k==='memo'||k==='bizNo')?'left':'right'}} />;
  };
  var formRow = function(curName, curCompanyName, curCompanyId, key, isAdd){
    return (
      <tr key={key} style={{background:'#eff6ff'}}>
        <td>
          {cellInput('name','거래처명',110)}
          {isAdd && <label style={{display:'inline-block',marginLeft:4,fontSize:11,color:ocrLoading?'#94a3b8':'#2563eb',cursor:ocrLoading?'default':'pointer',whiteSpace:'nowrap'}}>
            {ocrLoading?'인식중…':'📷 사업자등록증'}
            <input type="file" accept="image/*" disabled={ocrLoading} style={{display:'none'}} onChange={function(e){var f=e.target.files&&e.target.files[0]; ocrBizLicense(f); e.target.value='';}} />
          </label>}
        </td>
        <td>{cellInput('bizNo','사업자번호',110)}</td>
        <td>
          <select value={form.companyId} onChange={function(e){setF('companyId',e.target.value)}} style={{padding:'4px 6px',border:'1px solid #cbd5e1',borderRadius:6,maxWidth:150}}>
            <option value="">(미연결)</option>
            {companyOptions(curCompanyId, curCompanyName).map(function(o){return <option key={o.id} value={o.id}>{o.name}</option>})}
          </select>
        </td>
        <td style={{textAlign:'right'}}>{cellInput('serviceFee','0')}</td>
        <td style={{textAlign:'right'}}>{cellInput('wonbuFee','0')}</td>
        <td style={{textAlign:'right'}}>{cellInput('reissueFee','0')}</td>
        <td style={{textAlign:'center'}}><input type="checkbox" checked={!!form.issueTaxInvoice} onChange={function(e){setF('issueTaxInvoice',e.target.checked?1:0)}} title="세금계산서 발행형(체크) / 미발행형(해제)" /></td>
        <td style={{textAlign:'center'}}><input type="checkbox" checked={!!form.active} onChange={function(e){setF('active',e.target.checked?1:0)}} /></td>
        <td>{cellInput('memo','메모',100)}</td>
        <td style={{textAlign:'center',whiteSpace:'nowrap'}}>
          <button className="btn btn-blue btn-sm" onClick={save}>저장</button>{' '}
          <button className="btn btn-outline btn-sm" onClick={cancel}>취소</button>
        </td>
      </tr>
    );
  };

  return (
    <div>
      {/* 상단: 대행사 선택(admin) + 검색 + 안내 + 추가 */}
      <div style={{display:'flex',alignItems:'center',gap:12,marginBottom:12,flexWrap:'wrap'}}>
        {!isCancelAgency && (
          <select value={agencyId} onChange={function(e){setAgencyId(e.target.value);cancel();}} style={{padding:'8px 10px',border:'1px solid #cbd5e1',borderRadius:8}}>
            <option value="">대행사 선택…</option>
            {(agencies||[]).filter(function(a){return a.active}).map(function(a){return <option key={a.id} value={a.id}>{a.name}</option>})}
          </select>
        )}
        {canQuery() && <input value={q} onChange={function(e){setQ(e.target.value)}} placeholder="🔍 거래처명·사업자번호·회사 검색" style={{padding:'8px 10px',border:'1px solid #cbd5e1',borderRadius:8,minWidth:220}} />}
        {canQuery() && <span style={{color:'#475569',fontSize:13}}>{q.trim()?(<span>검색 <b>{shown.length}</b> / </span>):null}전체 <b>{clients.length}</b>곳 · 미입력 <b style={{color:blankCount?'#ea580c':'#475569'}}>{blankCount}</b>곳</span>}
        <div style={{flex:1}} />
        {canQuery() && <button className="btn btn-blue btn-sm" onClick={startAdd}>＋ 거래처 추가</button>}
        {canQuery() && <button className="btn btn-outline btn-sm" onClick={load}>🔄</button>}
      </div>

      {canQuery() && (
        <div style={{background:'#fffbeb',border:'1px solid #fde68a',borderRadius:8,padding:'8px 12px',marginBottom:12,fontSize:13,color:'#92400e'}}>
          💡 원부·재교부 단가는 <b>수수료(&gt;0)</b> 가 설정된 거래처에만 정산에 반영됩니다. 수수료 미입력 시 대행사 기본 수수료가 적용됩니다.<br/>
          🔗 <b>회사 연결</b> 후 자동정산이 해당 거래처 단가를 적용합니다. 연결 후보는 <b>이 대행사로 말소요청을 보낸 회사</b>만 표시됩니다{linkable.length===0 && <span> — <b>현재 0곳</b> (말소요청 발생 시 채워짐)</span>}.
        </div>
      )}

      {!canQuery() && <div style={{color:'#94a3b8',padding:'40px 0',textAlign:'center'}}>대행사를 선택하세요.</div>}

      {canQuery() && (
        <table className="data-table" style={{width:'100%',fontSize:14}}>
          <thead>
            <tr style={{background:'#f1f5f9',textAlign:'left'}}>
              <th>거래처명</th><th>사업자번호</th><th>연결 회사</th>
              <th style={{textAlign:'right'}}>수수료</th><th style={{textAlign:'right'}}>원부</th><th style={{textAlign:'right'}}>재교부</th>
              <th style={{textAlign:'center'}}>세금계산서</th><th style={{textAlign:'center'}}>활성</th><th>메모</th><th style={{textAlign:'center'}}>관리</th>
            </tr>
          </thead>
          <tbody>
            {showAdd && form && formRow('', '', '', 'addrow', true)}
            {shown.map(function(c){
              if(editId===c.id && form) return formRow(c.name, c.companyName, c.companyId, c.id, false);
              var blank = !c.serviceFee;
              return (
                <tr key={c.id} style={{background: c.active? (blank?'#fff7ed':'#fff') : '#f8fafc', borderBottom:'1px solid #e5e7eb', opacity:c.active?1:0.55}}>
                  <td>{c.name}{blank && <span style={{marginLeft:6,fontSize:11,color:'#ea580c',border:'1px solid #fdba74',borderRadius:4,padding:'1px 4px'}}>미입력</span>}</td>
                  <td style={{color:c.bizNo?'#334155':'#cbd5e1'}}>{c.bizNo || '-'}</td>
                  <td>{c.companyName || <span style={{color:'#cbd5e1'}}>미연결</span>}</td>
                  <td style={{textAlign:'right'}}>{c.serviceFee?fmt(c.serviceFee):<span style={{color:'#cbd5e1'}}>-</span>}</td>
                  <td style={{textAlign:'right'}}>{c.wonbuFee?fmt(c.wonbuFee):<span style={{color:'#cbd5e1'}}>-</span>}</td>
                  <td style={{textAlign:'right'}}>{c.reissueFee?fmt(c.reissueFee):<span style={{color:'#cbd5e1'}}>-</span>}</td>
                  <td style={{textAlign:'center'}}>{c.issueTaxInvoice===0
                    ? <span style={{fontSize:11,color:'#64748b',border:'1px solid #cbd5e1',borderRadius:4,padding:'1px 5px'}}>비발행</span>
                    : <span style={{fontSize:11,color:'#1d4ed8',border:'1px solid #bfdbfe',background:'#eff6ff',borderRadius:4,padding:'1px 5px'}}>세금계산서</span>}</td>
                  <td style={{textAlign:'center'}}>{c.active?'✅':'⛔'}</td>
                  <td style={{color:'#64748b'}}>{c.memo}</td>
                  <td style={{textAlign:'center',whiteSpace:'nowrap'}}>
                    <button className="btn btn-outline btn-sm" onClick={function(){startEdit(c)}}>수정</button>{' '}
                    <button className="btn btn-outline btn-sm" style={{color:'#dc2626'}} onClick={function(){remove(c)}}>삭제</button>
                  </td>
                </tr>
              );
            })}
            {shown.length===0 && !showAdd && <tr><td colSpan={10} style={{textAlign:'center',color:'#94a3b8',padding:'30px 0'}}>{q.trim()?'검색 결과 없음':'등록된 거래처가 없습니다.'}</td></tr>}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default CancelAgencyClients;
